import { collection, doc, getDoc, onSnapshot, query, where } from 'firebase/firestore';
import React, { useEffect, useState } from 'react';
import { db } from '../../services/firebaseConfig';
import moment from 'moment';
import { useNavigate } from 'react-router-dom';
import { Button, CardHeader, Skeleton } from '@mui/material';
import { ArrowBack } from '@mui/icons-material';
import boyImg from "../../images/blankPicBoy2.png";

export const ChatList = ({ userId }) => {
  const [conversations, setConversations] = useState([]);
  const [userDetails, setUserDetails] = useState({});
  const [isLoading, setIsLoading] = useState(true); // Loading state
  const navigate = useNavigate();
  const username = localStorage.getItem('username');

  useEffect(() => {
    const q = query(collection(db, 'conversations'), where('participants', 'array-contains', userId));

    const unsubscribe = onSnapshot(q, async (querySnapshot) => {
      setIsLoading(true);
      const fetchConversations = [];
      const userDetailPromises = [];

      querySnapshot.forEach((docSnapshot) => {
        const data = { id: docSnapshot.id, ...docSnapshot.data() };
        fetchConversations.push(data);

        const otherUserId = data.participants.find((id) => id !== userId);
        if (otherUserId && !userDetails[otherUserId]) {
          userDetailPromises.push(
            getDoc(doc(db, 'users', otherUserId)).then((userDoc) => ({
              userId: otherUserId,
              data: userDoc.exists() ? userDoc.data() : null,
            }))
          );
        }
      });

      const userDetailsResult = await Promise.all(userDetailPromises);
      const updatedUserDetails = { ...userDetails };

      userDetailsResult.forEach(({ userId, data }) => {
        if (data) updatedUserDetails[userId] = data;
      });

      const sortedConversations = fetchConversations.sort((a, b) => {
        const timeA = a.lastMessage?.timestamp?.seconds || 0;
        const timeB = b.lastMessage?.timestamp?.seconds || 0;
        return timeB - timeA;
      });

      setConversations(sortedConversations);
      setUserDetails(updatedUserDetails);
      setIsLoading(false); // Loading completed
    });

    return () => unsubscribe();
  }, [userId]);

  return (
    <div className="col-lg-9 col-12">
      <div className="editProfileBlock">
        <div className="prodileDetailsBlock mt-3">
          <CardHeader
            avatar={<ArrowBack sx={{ color: '#FF8008' }} onClick={() => navigate(-1)} />}
            title="Messenger"
            subheader="Conversations"
            titleTypographyProps={{ sx: { color: '#FF8008', fontSize: '20px', fontWeight: '500' } }}
          />
          {isLoading ? (
            Array.from({ length: 5 }).map((_, index) => (
              <div key={index} className="d-flex justify-content-between align-items-center msgBG">
                <div className="d-flex align-items-center">
                  <Skeleton variant="circular" width={50} height={50} />
                  <div className="flex-grow-1 ms-3 text-left">
                    <Skeleton variant="text" width="150px" />
                    <Skeleton variant="text" width="200px" />
                  </div>
                </div>
                <Skeleton variant="text" width="50px" />
              </div>
            ))
          ) : conversations.length > 0 ? (
            conversations.map((conversation) => {
              const { lastMessage, participants, id } = conversation;
              const otherUserId = participants.find((id) => id !== userId);
              const otherUser = userDetails[otherUserId] || {};
              const profilePic = otherUser?.profilePic || boyImg;
              const name = otherUser?.name || 'Unknown User';
              const lastMessageText = lastMessage?.message || 'No messages yet';
              const lastMessageTimestamp = lastMessage?.timestamp?.seconds
                ? moment(lastMessage.timestamp.seconds * 1000).fromNow()
                : 'No timestamp';

              const handleConversation = () => {
                navigate('/chat', { state: { chatId: id, recipientId: otherUserId } });
              };

              return (
                <div key={id} className={`d-flex justify-content-between align-items-center msgBG position-relative ${lastMessage?.status === 'sent' && lastMessage?.senderId !== username ? 'unreadChat' : ''
                  }`} onClick={handleConversation}>
                  <div className="d-flex align-items-center">
                    <div className="flex-shrink-0">
                      <Button onClick={handleConversation}>
                        <img
                          src={profilePic}
                          alt="Profile"
                          onError={(e) => (e.target.src = boyImg)}
                          style={{ width: '50px', height: '50px', borderRadius: '50%' }}
                        />
                      </Button>
                    </div>
                    <div className="flex-grow-1 ms-3 text-left">
                      <p className={`chatName ${lastMessage?.status === 'sent' && lastMessage?.senderId !== username ? 'fw-bold' : ''}`}>
                        {name}
                      </p>
                      <p className={`${lastMessage?.status === 'sent' && lastMessage?.senderId !== username ? 'fw-bold' : ''}`}>
                        {lastMessageText}
                      </p>
                    </div>
                  </div>
                  <div>
                    <p>{lastMessageTimestamp}</p>
                  </div>
                </div>
              );
            })
          ) : (
            <p>No conversations found.</p>
          )}
        </div>
      </div>
    </div>
  );
};
